var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidenav"},[_c('ul',_vm._l((_vm.pageList),function(page){return _c('li',{key:page.class,class:page.class,on:{"click":function($event){return _vm.currentPage(page)}}},[_c('a',[_c('b',{staticClass:"txt"},[_vm._v(_vm._s(page.title))])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1ff1ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/LeftSide.vue
// module id = null
// module chunks = 